import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertErrorTransparentIcon extends BaseIcon {
    getChildren = () => [
            <path d="M-9430-6647a7.009,7.009,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7A7.008,7.008,0,0,1-9430-6647Zm0-5.5h0l2.1,2.1a.983.983,0,0,0,.7.3.986.986,0,0,0,.7-.3.989.989,0,0,0,.3-.7.991.991,0,0,0-.3-.7l-2.1-2.1,2.1-2.2a.988.988,0,0,0,.3-.7.988.988,0,0,0-.3-.7.992.992,0,0,0-.7-.3.988.988,0,0,0-.7.3l-2.1,2.1-2.2-2.1a.994.994,0,0,0-.7-.3.988.988,0,0,0-.7.3.969.969,0,0,0,0,1.4l2.2,2.2-2.1,2.1a.991.991,0,0,0-.3.7.989.989,0,0,0,.3.7.992.992,0,0,0,.7.3.992.992,0,0,0,.7-.3l2.1-2.1Z" transform="translate(9437 6661)" fill="#f24e4e"/>
    ]
    getViewBox = () => '0 0 13.999 14'
}
